export const handleMobileAppClick = (
  url: string,
  event: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>
) => {
  if (event) {
    event.preventDefault()
    event.stopPropagation()
  }

  let openedNewWindow = false

  try {
    const newWindow = window.open(url, "_blank")

    if (newWindow && !newWindow.closed) {
      openedNewWindow = true
    } else {
      window.location.href = url
    }
  } catch (err) {
    window.location.href = url
  }

  if (process.env.NODE_ENV === "development") {
    console.log("📱 handleMobileAppClick executed", {
      userAgent: window.navigator.userAgent,
      openedNewWindow
    })
  }
} 